'use strict'

angular.module('rmBroadcast')
    .controller('BroadcastOverviewCtrl', require('./broadcast_overview_ctrl.js'))
    .controller('BroadcastFormCtrl', require('./broadcast_form_ctrl.js').default)
